import { combineReducers } from 'redux';
import localStylingReducer from './localStylingReducer';
import defaultStylingReducer from './defaultStylingReducer';

export const STYLING_STATE_PATH = 'styling';
export const LOCAL_STYLING_STATE_PATH = 'localStyling';
export const DEFAULT_SURVEY_STYLES_STATE_PATH = 'defaultSurveyStyles';

export default combineReducers({
  [LOCAL_STYLING_STATE_PATH]: localStylingReducer,
  [DEFAULT_SURVEY_STYLES_STATE_PATH]: defaultStylingReducer,
});
